import { useEffect, useState } from "react";
import axios from "axios";
import { CalendarDays, Clock, Users, Video, ArrowRight, Radio } from "lucide-react";
import { API } from "@/lib/api";
import { PATHWAY } from "@/data/offers";
import { Reveal } from "./Reveal";
import { InterestDialog } from "./InterestDialog";

const day = (iso) => new Date(iso).toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short", timeZone: "Asia/Kolkata" });

// Public list of batches the admin marked "Show on the website". Hidden entirely when none are open.
export const UpcomingBatches = () => {
  const [rows, setRows] = useState([]);
  const [pick, setPick] = useState(null);
  useEffect(() => { axios.get(`${API}/batches`).then((r) => setRows(Array.isArray(r.data) ? r.data : [])).catch(() => {}); }, []);
  if (!rows.length) return null;
  return (
    <section id="batches" data-testid="batches-section" className="mx-auto max-w-[1440px] px-5 pb-16 lg:px-10">
      <Reveal className="text-center">
        <p className="inline-flex items-center gap-1.5 rounded-full bg-teal-50 px-3 py-1 text-[12px] font-semibold uppercase tracking-[0.14em] text-[#0E9384]"><Radio className="h-3.5 w-3.5" /> Enrolling now</p>
        <h2 className="font-display mt-3 text-[32px] font-extrabold leading-[1.05] tracking-tight text-[#0B1B33] md:text-[44px]">Upcoming live batches</h2>
        <p className="mx-auto mt-3 max-w-2xl text-base text-slate-700 md:text-lg">Pick the timing that fits your week. Every class is live on Zoom, and recordings, notes and projects stay in your learning portal.</p>
      </Reveal>
      <div className="mt-8 grid gap-5 md:grid-cols-2 xl:grid-cols-3">
        {rows.map((b, i) => (
          <Reveal key={b.id} delay={i * 0.06}>
            <article data-testid="batch-card" className="flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
              <p className="text-[12px] font-semibold uppercase tracking-[0.14em] text-[#0E9384]">{b.course_title}</p>
              <h3 className="font-display mt-1 text-[22px] font-bold text-[#0B1B33]">{b.name}</h3>
              <ul className="mt-4 space-y-2 text-[14.5px] text-slate-700">
                <li className="flex items-center gap-2"><CalendarDays className="h-4 w-4 text-[#0E9384]" />Starts <b className="text-[#0B1B33]">{day(b.first_class || b.start_date)}</b></li>
                <li className="flex items-center gap-2"><Clock className="h-4 w-4 text-[#0E9384]" />{b.label} · {b.duration_min} min</li>
                <li className="flex items-center gap-2"><Video className="h-4 w-4 text-[#0E9384]" />{b.classes ? `${b.classes} live classes on Zoom` : "Live on Zoom"}</li>
                {b.seats && <li className="flex items-center gap-2"><Users className="h-4 w-4 text-[#0E9384]" />{b.seats} seats</li>}
              </ul>
              <div className="mt-auto flex items-center justify-between gap-3 pt-6">
                {b.fee && <p className="font-display text-[22px] font-bold text-[#0B1B33]">{b.fee}</p>}
                <button data-testid={`batch-reserve-${b.id}`} onClick={() => setPick(b)} className="btn-teal flex items-center gap-1.5 rounded-xl px-5 py-3 text-[15px] font-semibold">Reserve a seat <ArrowRight className="arrow h-4 w-4" /></button>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
      <p className="mt-6 text-center text-[13.5px] text-slate-600">Reserving is free and takes no payment. We confirm the fee, schedule and refund terms with you personally first.</p>
      <InterestDialog course={pick && PATHWAY.find((c) => c.key === pick.course)} note={pick ? `Batch: ${pick.name} (${pick.label}, starts ${day(pick.first_class || pick.start_date)})` : ""} onClose={() => setPick(null)} />
    </section>
  );
};
